import React from "react";
const PaperIcon = (props: { size: number; fillColor: string }) => {
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2.19995V17.8H16V6.15635L15.8314 5.96855L12.2314 2.36855L12.0436 2.19995H4ZM5.2 3.39995H11.2V6.99995H14.8V16.6H5.2V3.39995ZM12.4 4.26275L13.9378 5.79995H12.4V4.26275ZM7 8.19995V9.39995H13V8.19995H7ZM7 10.6V11.8H13V10.6H7ZM7 13V14.2H13V13H7Z"
        fill={props.fillColor}
      />
    </svg>
  );
};
export default PaperIcon;
